import Grid from '@mui/material/Grid2';
import { TextField, Button, MenuItem } from '@mui/material';
import RunButton from '../../../Header/RunButton';

const ReportCardHeader = ({
    username,
    setUsername,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    primaryEmail,
    setPrimaryEmail,
    userId,
    setUserId,
    localizedCountry,
    setLocalizedCountry,
    localizedLanguage,
    setLocalizedLanguage,
    unitId,
    setUnitId,
    hasAnyInput,
    handleRun,
    inFlight,
    locationLanguageData,
    unitOptions,
    cobrandOptions,
    cobrandId,
    setCobrandId,
}) => {
    const unitsOptionsMinus0 = unitOptions.filter((u) => u.id !== 0);

    // Reset all input values
    const handleResetFilters = () => {
        setUsername('');
        setFirstName('');
        setLastName('');
        setPrimaryEmail('');
        setUserId('');
        setLocalizedCountry('');
        setLocalizedLanguage('');
        setUnitId('');
        setCobrandId('');
    };

    const filterOptions = (options) =>
        Array.isArray(options)
            ? options.filter((v) => v != null && String(v).trim() !== '')
            : [];

    const localizedCountryOptions = filterOptions(
        locationLanguageData?.localizedCountries
    );
    const localizedLanguageOptions = filterOptions(
        locationLanguageData?.localizedLanguages
    );

    return (
        <div className="my-4 p-3">
            <div className="mb-2 flex items-start justify-start gap-2">
                <Button variant="outlined" size="small" onClick={handleResetFilters}>
                    Reset
                </Button>
            </div>
            <Grid container spacing={2}>
                <Grid>
                    <TextField
                        id="username-input"
                        label="Username"
                        value={username}
                        onChange={(e) => {
                            const value = e.target.value;
                            setUsername(value);
                        }}
                        helperText={'Allows partial matches'}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
                <Grid>
                    <TextField
                        id="first-name-input"
                        label="First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        helperText="Allows partial matches"
                        fullWidth
                        margin="normal"
                    />
                </Grid>
                <Grid>
                    <TextField
                        id="last-name-input"
                        label="Last Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        helperText="Allows partial matches"
                        fullWidth
                        margin="normal"
                    />
                </Grid>
                <Grid>
                    <TextField
                        id="primary-email-input"
                        label="Primary Email Address"
                        value={primaryEmail}
                        onChange={(e) => {
                            const value = e.target.value;
                            setPrimaryEmail(value);
                        }}
                        helperText={'Allows partial matches'}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
                <Grid>
                    <TextField
                        id="localized-country-input"
                        label="Localized Country"
                        select
                        value={localizedCountry}
                        onChange={(e) => setLocalizedCountry(e.target.value)}
                        fullWidth
                        margin="normal"
                        sx={{ minWidth: 200 }}
                    >
                        <MenuItem value="">
                            <em>Any</em>
                        </MenuItem>
                        <MenuItem value="__NULL__">
                            <em>None</em>
                        </MenuItem>
                        {localizedCountryOptions.map((lc) => (
                            <MenuItem key={lc} value={lc}>
                                {lc}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid>
                    <TextField
                        id="localized-language-input"
                        label="Localized Language"
                        select
                        value={localizedLanguage}
                        onChange={(e) => setLocalizedLanguage(e.target.value)}
                        fullWidth
                        margin="normal"
                        sx={{ minWidth: 200 }}
                    >
                        <MenuItem value="">
                            <em>Any</em>
                        </MenuItem>
                        <MenuItem value="__NULL__">
                            <em>None</em>
                        </MenuItem>
                        {localizedLanguageOptions.map((l) => (
                            <MenuItem key={l} value={l}>
                                {l}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid>
                    <TextField
                        id="unit-id-input"
                        label="Unit"
                        select
                        value={unitId}
                        onChange={(e) => setUnitId(e.target.value)}
                        fullWidth
                        margin="normal"
                        sx={{ minWidth: 200 }}
                    >
                        <MenuItem value="">
                            <em>Any</em>
                        </MenuItem>
                        <MenuItem value="0">
                            <em>None</em>
                        </MenuItem>
                        {unitsOptionsMinus0.map((uo) => (
                            <MenuItem key={uo.id} value={uo.id}>
                                {uo.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                {cobrandOptions.length > 1 && (
                    <Grid>
                        <TextField
                            id="cobrand-id-input"
                            label="Cobrand"
                            select
                            value={cobrandId}
                            onChange={(e) => setCobrandId(e.target.value)}
                            fullWidth
                            margin="normal"
                            sx={{ minWidth: 200 }}
                        >
                            <MenuItem value="">
                                <em>Any</em>
                            </MenuItem>
                            {cobrandOptions.map((co) => (
                                <MenuItem key={co.id} value={co.id}>
                                    {co.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                )}
            </Grid>
            <RunButton
                onClick={handleRun}
                isLoading={inFlight}
                isDisabled={inFlight || !hasAnyInput}
            />
        </div>
    );
};

export default ReportCardHeader;
